<button id="bars-external" type="button" [ngClass]="{'navbar-open': isNavbarOpen}" (click)="toggleNavbar()">
    <i class="fas fa-bars"></i>
</button>

<nav class="navbar" [ngClass]="{'navbar-open': isNavbarOpen}">
    <div class="nav-header">
        <button id="bars" type="button" [ngClass]="{'navbar-open': isNavbarOpen}" (click)="toggleNavbar()">
            <i class="fas fa-bars"></i>
        </button>
        <img (click)="redirectTo('')" src="assets/images/logo.png" alt="A-Square Logo" class="brand-logo" />
    </div>

    <ul class="nav-list">
        <li><button type="button" (click)="redirectTo('')">Home</button></li>
        <li><button type="button" (click)="redirectTo('about-us')">About Us</button></li>
        <li><button type="button" (click)="redirectTo('pricing')">Pricing</button></li>
        <li><button type="button" (click)="redirectTo('contact-us')">Contact Us</button></li>
    </ul>

    <div class="login-signup">
        <button type="button" id="login-button" (click)="redirectTo('subscriber-login')">Login</button>
        <button type="button" id="signup-button" (click)="redirectTo('subscriber-signup')">Signup</button>
    </div>
</nav>
